
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/[others]/[firstLevel]",
      function () {
        return require("private-next-pages/[region]/[language]/[others]/[firstLevel]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/[others]/[firstLevel]"])
      });
    }
  